<section
  class="filters-dialog"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="titleId()">
  <header class="filters-dialog__head">
    <h2 class="filters-dialog__title" [id]="titleId()">
      {{ 'advanceFiltering.filters' | translate }}
    </h2>
    <button
      type="button"
      class="filters-dialog__close"
      (click)="closed.emit()"
      [attr.aria-label]="'global.close' | translate">
      <i class="iconsax" icon-name="x"></i>
    </button>
  </header>
  <div class="filters-dialog__body custom-scrollbar">
    <ng-content />
  </div>
  <footer class="filters-dialog__footer">
    <pwj-button
      class="filters-dialog__remove"
      variant="normal"
      size="medium"
      icon="trash"
      (clicked)="removed.emit()">
      {{ 'advanceFiltering.removeTheFilter' | translate }}
    </pwj-button>
    <pwj-button
      class="filters-dialog__apply"
      variant="primary"
      size="large"
      (clicked)="applied.emit()">
      {{ 'advanceFiltering.applyFilters' | translate }}
    </pwj-button>
  </footer>
</section>
